export class Credits {
    static jobRun = 10;
}
